<template>
    <div>
        <div v-if='!empty'>

            <div class='container'>
                <div class='row'>
                <div class='col-sm-12'>
                <h2>{{bundle.title}}</h2>
                <h3>{{bundle.subtitle}}</h3>

                <iframe class='youtubeViewer' v-if='bundle.videourl' :src="'https://www.youtube-nocookie.com/embed/' + videoId + '?cc_load_policy=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                </div>
                </div>

                <div class='row resourceContent'>
                    <div class='col-sm-9' v-html='bundle.content'>
                        
                    </div>
                    <div class='col-sm-3'>
                       
                    </div>
                </div>

                <div class='row'>
                    <div class='col-md-12'>
                        <transition-group v-if='bundle.modules.length > 0' name="list" tag='div' class='resourceTiles'>
                        <module-tile v-for='module in bundle.modules' :key='module.slug' :module='module'></module-tile>
                        </transition-group>

                         <image-gallery :gallery='bundle.gallery' :carousel='false'></image-gallery>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import EducationModuleTile from '../../components/EducationModuleTile'
import _ from 'lodash'
import ImageGallery from '../../components/ImageGallery'

export default {
    props: ['slug'],
    data() {
        return {
            bundle: {}
        }
    },
    computed: {
        videoId() {
            return util.videoId(this.bundle.videourl);
        },
        empty() {
            return _.isEmpty(this.bundle);
        }
    },
    methods: {
        refresh() {
            let query = JSON.stringify({ "id": this.slug });
            axios.get(`${this.$api}/education/bundles?query=${query}`).then((response) => {
                this.bundle = response.data;
            });
        }
    },
    created() {
        if (this.$route.params.bundle) {
            this.bundle = this.$route.params.bundle;
        } else {
            this.refresh();
        }
    },
    components: {
        'module-tile': EducationModuleTile,
        'image-gallery': ImageGallery
    }
}
</script>